import { render, staticRenderFns } from "./Edzesek.html?vue&type=template&id=177248f8&"
import script from "./Edzesek.js?vue&type=script&lang=js&"
export * from "./Edzesek.js?vue&type=script&lang=js&"
import style0 from "./Edzesek.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports